import { Component, EventEmitter, Output } from '@angular/core'
import { QuestionTypeView, QuestionViewService, IQuestionAnswer } from '..'

@Component({
  selector: 'mp-table-analysis-question-view',
  templateUrl: './table-analysis-question-view.html',
  styleUrls: ['./table-analysis-question-view.scss']
})
export class TableAnalysisQuestionViewComponent extends QuestionTypeView {
  public reviewMode: boolean = false

  @Output() public optionSelected: EventEmitter<IQuestionAnswer> = new EventEmitter()

  public get answerChoiceGroups() {
    return this.question.answerChoiceGroups
  }

  public get firstAnswerChoice(){
    return this.question.answerChoiceGroups[0].answerChoices[0]
  }

  public get secondAnswerChoice(){
    return this.question.answerChoiceGroups[0].answerChoices[1]
  }

  public constructor(
     _questionViewService: QuestionViewService
  ) { super(_questionViewService) }

  public ngOnChanges() {
    this.reviewMode = this._questionViewService.reviewMode
  }

  public selectOption(value, answerChoiceFormGroup) {
    if (this.reviewMode || answerChoiceFormGroup.disabled) {
      return
     }
     answerChoiceFormGroup.setValue({answerChoice: value})
    this._questionViewService.questionAnswered.emit(this.getQuestionAnswers())

  }

  public isSelected(option, formGroup) {
    return formGroup.value.answerChoice === option.value
  }

  public isCorrect(option): boolean {
    return this._questionViewService.question.isAnswerChoiceCorrect(option.value)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/table-analysis-question-view/table-analysis-question-view.component.ts